import { useQuery } from '@tanstack/react-query';
import { flows } from '@repletoryreach/sdk-api';

/**
 * The business's live sources and API connections, for the Look up step and for Web API steps on a saved connection
 * (19 October 2026). Shared with the Knowledge page's cache, so a source added there shows here at once.
 */
export function useApiSetup() {
  const sources = useQuery({ queryKey: ['kb-sources'], queryFn: () => flows.listKbSources(), staleTime: 60_000, retry: false });
  const connections = useQuery({ queryKey: ['api-connections'], queryFn: () => flows.listApiConnections(), staleTime: 60_000, retry: false });
  return {
    sources: sources.data?.data ?? [],
    connections: connections.data?.data ?? [],
    loading: sources.isPending || connections.isPending
  };
}
